<template>
    <vue-modal
        v-model="modal.isVisible"
        :header="false"
        :footer="false"
        :closable="false"
        :backdrop="false"
        :modalBodyClass="$prefixClass.modal + '-redirect'"
    >
        <i class="fad fa-spinner fa-pulse m-b-13"></i>
        <p class="content">Redirect to {{page}} </p>
    </vue-modal>
</template>
<script>
export default {
    name: "ModalRedirect",
    props: {
        value: {
            type: Object,
            required: true
        },
        page: {
            type: String,
            default: 'dashboard'
        }
    },
    data() {
        return {

        }
    },
    computed: {
        modal: {
            get: function() {
                return this.value
            },
            set: function(newValue) {
                this.$emit('input', newValue)
            }
        },
    },
    methods: {
    }
}
</script>
<style lang="scss">
    .#{$modal}-redirect {
        .#{$modal}-body {
            padding: 32px;
        }
        .fa-spinner {
           font-size: 3rem;
           color: $success-color;
        }

        .content {
            font-size: 20px;
            font-weight: 600;
            margin-bottom: 0;
        }
    }
</style>
